import { Instance, types } from 'mobx-state-tree';

import AlbumModel, { IAlbumModelSnapshotIn } from './models/AlbumModel';
import TrackModel, { ITrackModel, ITrackModelSnapshotIn } from './models/TrackModel';

const TrackStore = types
    .model('TrackStore', {
        tracks: types.map(TrackModel),
        albums: types.map(AlbumModel),
    })
    .views(self => ({
        getTrack(trackId: string) {
            return self.tracks.get(trackId);
        },
        getAlbum(albumId: string) {
            return self.albums.get(albumId);
        },
    }))
    .actions(self => {
        const addAlbum = (album: IAlbumModelSnapshotIn) => {
            self.albums.set(album.id, album);
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            return self.albums.get(album.id)!;
        };

        const addTrackFromSimplified = (simplifiedTrack: SpotifyApi.TrackObjectSimplified, album: IAlbumModelSnapshotIn) => {
            const track: ITrackModelSnapshotIn = {
                id: simplifiedTrack.id,
                uri: simplifiedTrack.uri,
                name: simplifiedTrack.name,
                duration: simplifiedTrack.duration_ms,
                artists: simplifiedTrack.artists.map(artist => artist.name).join(', '),
                imageUrl: album.image,
            };

            self.tracks.set(track.id, track);
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            return self.tracks.get(track.id)!;
        };

        const addTrack = (fullTrack: SpotifyApi.TrackObjectFull) => {
            const album = addAlbum({
                id: fullTrack.album.id,
                name: fullTrack.album.name,
                artist: fullTrack.artists.map(artist => artist.name).join(', '),
                image: fullTrack.album.images.length ? fullTrack.album.images[0].url : '',
            });

            const track: ITrackModelSnapshotIn = {
                id: fullTrack.id,
                uri: fullTrack.uri,
                name: fullTrack.name,
                duration: fullTrack.duration_ms,
                artists: fullTrack.artists.map(artist => artist.name).join(', '),
                imageUrl: album.image,
            };

            self.tracks.set(track.id, track);
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            return self.tracks.get(track.id)!;
        };

        const addTrackFromDB = (fullTrack: ITrackModel) => {
            const track: ITrackModelSnapshotIn = {
                id: fullTrack.id,
                uri: fullTrack.uri,
                name: fullTrack.name,
                duration: fullTrack.duration,
                artists: fullTrack.artists,
                imageUrl: fullTrack.imageUrl,
            };
            self.tracks.set(track.id, track);
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            return self.tracks.get(track.id)!;
        };

        return { addTrack, addAlbum, addTrackFromDB, addTrackFromSimplified };
    });

export interface ITrackStore extends Instance<typeof TrackStore> {}

export default TrackStore;
